import {
  Flex,
  Text,
  Heading,
  Image,
  VStack,
  HStack,
  Alert,
  AlertIcon,
  Button
} from '@chakra-ui/react'
import BaotreeLogo from '../components/UI/BaotreeLogo'
import React from 'react'

import { images } from 'theme'
import { VscRefresh, VscArrowLeft } from 'react-icons/vsc'

type ErrorBoundaryProps = {
  children: React.ReactNode
}
type State = {
  error: React.ErrorInfo | null
  errorInfo: React.ErrorInfo | null
}
class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  state: State = { error: null, errorInfo: null }

  componentDidCatch(error: any, errorInfo: any) {
    document.title = 'Baotree - Error'
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  render() {
    if (this.state.errorInfo) {
      return (
        // Deliberately not PageWrap. This boundary sits OUTSIDE the router,
        // and PageWrap renders the billing banner, which reads the current
        // route: the error page itself threw, so every crash in the app ended
        // as a blank white screen instead of this recovery page.
        <Flex
          bg="white"
          minH="100vh"
          w="100%"
          justify="center"
          align="center"
          p={4}
          flexDir="column"
        >
          <HStack>
            <Image
              src={images.error}
              fallbackSrc={images.noImage}
              objectFit="contain"
              alt="Baotree logo"
              w={500}
            />
            <VStack maxW={500} spacing={4} alignItems="flex-start">
              <Heading as="h3" textAlign="left" mb={4}>
                Error
              </Heading>
              <Text fontSize="sm">
                Please send a screenshot of this error page to customers@baotree.io THEN you can
                refresh the page or go back to the homepage by using the buttons below.
              </Text>
              <Alert fontSize="sm" status="error">
                <AlertIcon />
                {this.state.error && this.state.error.toString()}
              </Alert>
              <Alert fontSize="sm" variant="top-accent" status="error">
                <Text noOfLines={8}>{this.state.errorInfo.componentStack}</Text>
              </Alert>
              <HStack spacing={3}>
                <Button
                  colorScheme="gray"
                  leftIcon={<VscArrowLeft />}
                  variant="ghost"
                  fontSize="sm"
                  onClick={() => window.location.replace('/')}
                >
                  Go to home page
                </Button>

                <Button
                  colorScheme="gray"
                  leftIcon={<VscRefresh />}
                  fontSize="sm"
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </Button>
              </HStack>
            </VStack>
          </HStack>
          <BaotreeLogo />
        </Flex>
      )
    }

    return <>{this.props.children}</>
  }
}

export default ErrorBoundary
